<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
      </div>
      <el-form
        ref="firstForm"
        :model="firstForm"
        :rules="firstRules"
        label-width="120px"
      >
        <div style="width: 500px">
          <el-form-item label="电站名称">
            <el-input
              v-model="firstForm.stationName"
              style="width: 100%"
              disabled
            />
          </el-form-item>
          <el-form-item label="归属运营商">
            <!-- <el-select v-model="firstForm.equipmentOwnerID" filterable remote disabled style="width:100%;" reserve-keyword placeholder="请输入搜索关键词" :remote-method="selectPlant">
              <el-option v-for="item in plantList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select> -->
            <el-input
              v-model="firstForm.equipmentOwnerID"
              style="width: 100%"
              disabled
            />
          </el-form-item>
          <el-form-item label="运营状态" prop="operatorStatus">
            <el-select
              v-model="firstForm.operatorStatus"
              placeholder="请选择运营状态"
              style="width: 100%"
            >
              <el-option label="待建设" :value="0" />
              <el-option label="新建中" :value="1" />
              <el-option label="待验收" :value="2" />
              <el-option label="运营中" :value="3" />
            </el-select>
          </el-form-item>
        </div>

        <div style="display: flex; align-items: center">
          <el-form-item label="电站地址" prop="areaCode" style="width: 500px">
            <el-cascader
              ref="three"
              v-model="firstForm.areaCode"
              :options="optionsThree"
              style="width: 100%"
              placeholder="请选择省市区"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item
            label=""
            prop="address"
            style="width: calc(100% - 520px); margin-left: 20px"
            label-width="0px"
          >
            <el-input
              v-model="firstForm.address"
              style="width: 80%; float: left"
              placeholder="请输入详细地址"
            />
            <el-button
              type="primary"
              round
              style="margin-left: 5%; width: 15%"
              @click="isShowMapClick"
              >地图定位</el-button
            >
          </el-form-item>
        </div>
        <el-form-item v-show="isShowMap" label="" style="width: 1000px">
          <div id="container" />
          <div>当前定位：{{ newAddress }}</div>
        </el-form-item>
        <div style="width: 500px">
          <el-form-item label="电站位置" prop="stationLocation">
            <el-checkbox-group
              v-model="firstForm.stationLocation"
              style="width: 100%"
            >
              <el-checkbox label="地上电站" />
              <el-checkbox label="地下电站" />
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="是否增容" prop="canAddCapacity">
            <el-radio-group
              v-model="firstForm.canAddCapacity"
              style="width: 100%"
            >
              <el-radio :label="false">增容</el-radio>
              <el-radio :label="true">不增容</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可用电容" prop="capacitanceSize">
            <el-input
              v-model="firstForm.capacitanceSize"
              style="width: 100%"
              placeholder="请输入可用电容"
              @input="checkCap"
            >
              <template slot="append">KV-A</template>
            </el-input>
          </el-form-item>
          <el-form-item label="场地属性" prop="siteProperties">
            <el-radio-group
              v-model="firstForm.siteProperties"
              style="width: 100%"
            >
              <el-radio label="独立场站" />
              <el-radio label="混合场站" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电站类型" prop="stationType">
            <el-select
              v-model="firstForm.stationType"
              placeholder="请选择电站类型"
              style="width: 100%"
            >
              <el-option label="公共" :value="1" />
              <el-option label="个人" :value="50" />
              <el-option label="公交(专用)" :value="100" />
              <el-option label="环卫(专用)" :value="101" />
              <el-option label="物流(专用)" :value="102" />
              <el-option label="出租车(专用)" :value="103" />
              <el-option label="其他" :value="255" />
            </el-select>
          </el-form-item>
          <el-form-item label="建设场所" prop="construction">
            <el-select
              v-model="firstForm.construction"
              placeholder="请选择建设场所"
              style="width: 100%"
            >
              <el-option label="居民区" :value="1" />
              <el-option label="公共机构" :value="2" />
              <el-option label="企事业单位" :value="3" />
              <el-option label="写字楼" :value="4" />
              <el-option label="工业园区" :value="5" />
              <el-option label="交通枢纽" :value="6" />
              <el-option label="大型文体设施" :value="7" />
              <el-option label="城市绿地" :value="8" />
              <el-option label="大型建筑配建停车场" :value="9" />
              <el-option label="路边停车场" :value="10" />
              <el-option label="城际高速服务区" :value="11" />
              <el-option label="其他" :value="255" />
            </el-select>
          </el-form-item>
          <el-form-item label="移动端可见性" prop="siteProperties">
            <el-radio-group v-model="firstForm.appCanSee" style="width: 100%">
              <el-radio :label="true">可见</el-radio>
              <el-radio :label="false">不可见</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="开业时间" prop="officialRunTime">
              <el-date-picker
                v-model="firstForm.officialRunTime"
                format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否峰谷分时" prop="periodFee">
              <el-radio-group v-model="firstForm.periodFee" style="width: 100%">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否有监控" prop="videoMonitor">
              <el-radio-group v-model="firstForm.videoMonitor">
                <el-radio :label="0">无监控</el-radio>
                <el-radio :label="1">有监控</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="增容" prop="capacity">
              <el-input-number v-model="firstForm.capacity"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8"
            ><el-form-item label="户号" prop="electricityUserNo">
              <el-input
                v-model="firstForm.electricityUserNo"
                placeholder="请输入户号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供电类型" prop="powerSupplyType">
              <el-radio-group v-model="firstForm.powerSupplyType">
                <el-radio :label="0">转供电</el-radio>
                <el-radio :label="1">直供电</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电单价</span>
      </div>
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-row v-for="(item, index) in editForm.types" :key="index">
          <div
            style="
              display: flex;
              justify-content: space-between;
              position: relative;
            "
          >
            <el-form-item
              :label="index === 0 ? '价格类别' : ''"
              style="width: 120px"
            />
            <el-form-item
              label="类别名称"
              :prop="'types.' + index + '.name'"
              :rules="editFormRules.name"
              style="width: calc(33% - 65px)"
            >
              <el-input
                v-model="item.name"
                placeholder="请输入类别名称"
                style="width: 100%"
                @input="addPriceTypeClick()"
              />
            </el-form-item>
            <el-form-item
              label="电费"
              :prop="'types.' + index + '.elecMoney'"
              :rules="editFormRules.elecMoney"
              style="width: calc(33% - 65px)"
            >
              <el-input
                v-model="item.elecMoney"
                type="number"
                style="width: 100%"
                placeholder="请输入电费单价"
                @input="addPriceTypeClick()"
                @blur="changeElecMoney(item.elecMoney)"
              >
                <template slot="append">元/度</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="服务费"
              :prop="'types.' + index + '.serviceMoney'"
              :rules="editFormRules.serviceMoney"
              style="width: calc(33% - 65px)"
            >
              <el-input
                v-model="item.serviceMoney"
                type="number"
                style="width: 100%"
                placeholder="请输入服务费单价"
                @input="addPriceTypeClick()"
                @blur="changeServiceMoney(item.serviceMoney)"
              >
                <template slot="append">元/度</template>
              </el-input>
            </el-form-item>
            <el-button
              v-if="editForm.types.length > 1"
              style="margin-left: 10px; height: 40px"
              type="danger"
              size="small"
              @click="removeRow(index)"
              >删除{{ item.priceType }}</el-button
            >
          </div>
        </el-row>
        <el-row>
          <div
            v-show="editForm.types.length < 10"
            style="
              margin-left: 130px;
              margin-bottom: 20px;
              width: calc(100% - 132px);
              height: 32px;
              border: 1px dashed #5082e4;
            "
          >
            <div
              style="
                color: #5082e4;
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 32px;
                cursor: pointer;
              "
              @click="addRow"
            >
              <i class="iconfont el-icon-plus" />
              <span style="margin-left: 10px">增加类别</span>
            </div>
          </div>
        </el-row>
        <div v-if="editForm.types.length > 1 && editForm.ranges.length > 0">
          <el-row v-for="(item, index) in editForm.ranges" :key="index">
            <div
              style="
                display: flex;
                justify-content: space-between;
                position: relative;
              "
            >
              <el-form-item
                :label="index === 0 ? '价格设置' : ''"
                style="width: 120px"
              />
              <el-form-item
                label="开始时间"
                :prop="'ranges.' + index + '.priceStartPeriod'"
                :rules="editFormRules.priceStartPeriod"
                style="width: calc(33% - 65px)"
              >
                <el-select
                  v-model="item.priceStartPeriod"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                  @visible-change="startShowClick($event, item, index)"
                  @focus="selectFocusTime(1, index, item)"
                >
                  <el-option
                    v-for="item in startTimeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="结束时间"
                :prop="'ranges.' + index + '.priceEndPeriod'"
                :rules="editFormRules.priceEndPeriod"
                style="width: calc(33% - 65px)"
              >
                <el-select
                  v-model="item.priceEndPeriod"
                  placeholder="请选择结束时间"
                  style="width: 100%"
                  @visible-change="endShowClick($event, item, index)"
                  @change="canAddBtn"
                  @focus="selectFocusTime(2, index, item)"
                >
                  <el-option
                    v-for="item in endTimeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="类别名称"
                :prop="'ranges.' + index + '.priceType'"
                :rules="editFormRules.priceType"
                style="width: calc(33% - 65px)"
              >
                <el-select
                  ref="optionRef"
                  v-model="item.priceType"
                  placeholder="请选择价格类别"
                  style="width: 100%"
                  @change="handlePriceChange(item.priceType, index)"
                >
                  <el-option
                    v-for="item in priceTypeArray"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-button
                style="margin-left: 10px; height: 40px"
                type="danger"
                size="small"
                @click="removePriceTypeRow(index)"
                >删除{{ item.priceType }}</el-button
              >
            </div>
          </el-row>
          <el-row
            v-if="isEnd"
            style="display: flex; margin-left: 130px; width: calc(100% - 130px)"
          >
            <el-input
              placeholder="剩余时间价格统一选择"
              disabled
              style="width: 72%; margin-right: 3%"
            />
            <el-form-item label="" label-width="0px" prop="" style="width: 25%">
              <el-select
                v-model="editForm.end"
                placeholder="请选择价格类别"
                style="width: 100%"
                @change="
                  handlePriceChange(editForm.end, editForm.types.length - 1)
                "
              >
                <el-option
                  v-for="item in priceTypeArray"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <div
              v-show="editForm.ranges.length < 48"
              style="
                margin-left: 130px;
                margin-bottom: 20px;
                width: calc(100% - 132px);
                height: 32px;
                border: 1px dashed #5082e4;
              "
            >
              <div
                style="
                  color: #5082e4;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  line-height: 32px;
                  cursor: pointer;
                "
                @click="addPriceTypeRow"
              >
                <i class="iconfont el-icon-plus" />
                <span style="margin-left: 10px">增加</span>
              </div>
            </div>
          </el-row>
        </div>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">服务费分润设置</span>
      </div>
      <el-form
        ref="profitForm"
        :model="profitForm"
        label-width="120px"
        :rules="profitRules"
      >
        <div style="width: 100%">
          <el-form-item label="分润模式" prop="mode">
            <el-radio-group
              v-model="profitForm.mode"
              style="width: 100%"
              disabled
            >
              <el-radio label="PERCENT">固定折扣</el-radio>
              <el-radio label="FIXED">固定价格</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="profitForm.mode === 'PERCENT'">
            <div v-for="(item, index) in profitForm.shareBl" :key="index">
              <el-form-item :label="index === 0 ? '分润方设置' : ' '">
                <div style="display: flex; align-items: center">
                  <el-form-item
                    v-if="index === 0"
                    label="运营商分润比例"
                    :prop="'shareBl.' + index + '.value'"
                    style="width: 300px"
                  >
                    <el-input
                      v-model="item.value"
                      type="number"
                      style="width: 100%"
                      disabled
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                  <template v-else>
                    <el-form-item
                      label="参与分润方"
                      :prop="'shareBl.' + index + '.type'"
                      :rules="profitRules.type"
                      style="width: 300px"
                    >
                      <el-select
                        v-model="item.type"
                        placeholder="请选择参与分润方"
                        style="width: 100%"
                        @change="getOperator"
                      >
                        <el-option
                          v-for="item in shareArray"
                          :key="item.id"
                          :label="item.loginName"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="分润比例"
                      :prop="'shareBl.' + index + '.value'"
                      :rules="profitRules.value"
                      style="width: 300px"
                    >
                      <el-input
                        v-model="item.value"
                        type="number"
                        style="width: 100%"
                        @blur="getOperator"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </template>
                  <div style="margin-left: 20px">
                    <el-button
                      v-if="
                        index === profitForm.shareBl.length - 1 &&
                        profitForm.shareBl.length < shareArray.length + 1
                      "
                      type="primary"
                      size="small"
                      @click="addshareBl"
                      >增加</el-button
                    >
                    <el-button
                      v-if="profitForm.shareBl.length > 1 && index !== 0"
                      type="danger"
                      size="small"
                      @click="delshareBl(index)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </el-form-item>
            </div>
          </template>
          <template v-else>
            <div v-for="(item, index) in profitForm.shareJe" :key="index">
              <el-form-item :label="index === 0 ? '分润方设置' : ' '">
                <div style="display: flex; align-items: center">
                  <el-form-item
                    label="参与分润方"
                    :prop="'shareJe.' + index + '.type'"
                    :rules="profitRules.type"
                    style="width: 300px"
                  >
                    <el-select
                      v-model="item.type"
                      placeholder="请选择参与分润方"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in shareArray"
                        :key="item.id"
                        :label="item.loginName"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="分润金额"
                    :prop="'shareJe.' + index + '.value'"
                    :rules="profitRules.value1"
                    style="width: 300px"
                  >
                    <el-input
                      v-model="item.value"
                      type="number"
                      style="width: 100%"
                    >
                      <template slot="append">元/度</template>
                    </el-input>
                  </el-form-item>
                  <div style="margin-left: 20px">
                    <el-button
                      v-if="
                        index === profitForm.shareJe.length - 1 &&
                        profitForm.shareJe.length < shareArray.length
                      "
                      type="primary"
                      size="small"
                      @click="addshareJe"
                      >增加</el-button
                    >
                    <el-button
                      v-if="profitForm.shareJe.length > 1"
                      type="danger"
                      size="small"
                      @click="delshareJe(index)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </el-form-item>
            </div>
          </template>
        </div>
      </el-form>
    </el-card>
    <!-- <el-card shadow="never">
      <div slot="header">
        <span class="title">占用收费设置</span>
      </div>
      <el-form ref="occupyForm" :model="occupyForm" label-width="120px" :rules="occupyRules">
        <div style="width:500px">
          <el-form-item label="是否收取占用费" prop="collect">
            <el-radio-group v-model="occupyForm.collect" style="width:100%;">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="occupyForm.collect">
            <el-form-item label="停车缓冲时长" prop="buffDuration">
              <div style="display:flex;align-items: center;justify-content: space-between;">
                <el-input v-model="occupyForm.buffDuration" placeholder="请输入预留给用户充完电拔枪离场时长" style="width:calc(100% - 60px);" />
                <span>分钟</span>
              </div>
            </el-form-item>
            <el-form-item label="超时计费" prop="overMoney">
              <div style="display:flex;align-items: center;justify-content: space-between;">
                <el-input v-model="occupyForm.overMoney.money" placeholder="请输入超时收费" style="width:150px;" />
                <span>元/</span>
                <el-input v-model="occupyForm.overMoney.time" placeholder="时长" style="width:150px;" />
                <span>分钟</span>
              </div>
            </el-form-item>
          </template>
        </div>
      </el-form>
    </el-card> -->
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站配置</span>
      </div>
      <el-form
        ref="lastForm"
        :model="lastForm"
        label-width="120px"
        :rules="lastRules"
      >
        <div style="width: 500px">
          <el-form-item label="场站道闸" prop="brake">
            <el-radio-group v-model="lastForm.brake" style="width: 100%">
              <el-radio :label="false">无道闸</el-radio>
              <el-radio :label="true">有道闸</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="停车说明" prop="parkInstruction">
            <el-input
              v-model="lastForm.parkInstruction"
              placeholder="请输入场站停车费说明"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="站点描述" prop="stationRemark">
            <el-input
              v-model="lastForm.stationRemark"
              type="textarea"
              :rows="4"
              placeholder="请输入站点描述"
            />
          </el-form-item>
          <el-form-item label="站点服务设施" prop="siteService">
            <el-select
              v-model="lastForm.siteService"
              multiple
              placeholder="请选择建设场所"
              style="width: 100%"
            >
              <el-option label="免费停车" :value="0" />
              <el-option label="免费WiFi" :value="1" />
              <el-option label="对外开放" :value="2" />
              <el-option label="空调休息室" :value="3" />
              <el-option label="按摩室" :value="4" />
              <el-option label="游泳室" :value="5" />
            </el-select>
          </el-form-item>
          <el-form-item label="周边基础设施" prop="aroundService">
            <el-select
              v-model="lastForm.aroundService"
              multiple
              placeholder="请选择周边基础设施"
              style="width: 100%"
            >
              <el-option label="便利店" :value="0" />
              <el-option label="公厕" :value="1" />
              <el-option label="商场" :value="2" />
              <el-option label="近学校" :value="3" />
              <el-option label="近地铁站" :value="4" />
              <el-option label="近高铁站" :value="5" />
            </el-select>
          </el-form-item>
          <el-form-item label="开放时间说明" prop="busineHoursInstruction">
            <el-input
              v-model="lastForm.busineHoursInstruction"
              placeholder="请输入开放时间说明"
              style="width: 100%"
            />
          </el-form-item>
        </div>

        <el-form-item label="电站图片">
          <div
            style="width: 90%; display: flex; justify-content: space-between"
          >
            <div
              style="display: flex; flex-direction: column; text-align: center"
            >
              <el-upload
                class="avatar-uploader"
                :action="action"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                accept=".jpg, .jpeg, .png"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <span
                  v-if="imageUrl"
                  class="el-upload-action"
                  @click.stop="handleRemove()"
                >
                  <i class="el-icon-delete" />
                </span>
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="font-size: 12px"
                  >主入口图</i
                >
              </el-upload>
            </div>
            <div
              style="display: flex; flex-direction: column; text-align: center"
            >
              <el-upload
                class="avatar-uploader"
                :action="action"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess1"
                :on-remove="handleRemove1"
                :before-upload="beforeAvatarUpload"
                accept=".jpg, .jpeg, .png"
              >
                <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
                <span
                  v-if="imageUrl1"
                  class="el-upload-action"
                  @click.stop="handleRemove1()"
                >
                  <i class="el-icon-delete" />
                </span>
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="font-size: 12px"
                  >标志路径</i
                >
              </el-upload>
            </div>
            <div
              style="display: flex; flex-direction: column; text-align: center"
            >
              <el-upload
                class="avatar-uploader"
                :action="action"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess2"
                :on-remove="handleRemove2"
                :before-upload="beforeAvatarUpload"
                accept=".jpg, .jpeg, .png"
              >
                <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
                <span
                  v-if="imageUrl2"
                  class="el-upload-action"
                  @click.stop="handleRemove2()"
                >
                  <i class="el-icon-delete" />
                </span>
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="font-size: 12px"
                  >电站全景</i
                >
              </el-upload>
            </div>
            <div
              style="display: flex; flex-direction: column; text-align: center"
            >
              <el-upload
                class="avatar-uploader"
                :action="action"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess3"
                :on-remove="handleRemove3"
                :before-upload="beforeAvatarUpload"
                accept=".jpg, .jpeg, .png"
              >
                <img v-if="imageUrl3" :src="imageUrl3" class="avatar" />
                <span
                  v-if="imageUrl3"
                  class="el-upload-action"
                  @click.stop="handleRemove3()"
                >
                  <i class="el-icon-delete" />
                </span>
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="font-size: 12px"
                  >电桩特写</i
                >
              </el-upload>
            </div>
            <div
              style="display: flex; flex-direction: column; text-align: center"
            >
              <el-upload
                class="avatar-uploader"
                :action="action"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess4"
                :on-remove="handleRemove4"
                :before-upload="beforeAvatarUpload"
                accept=".jpg, .jpeg, .png"
              >
                <img v-if="imageUrl4" :src="imageUrl4" class="avatar" />
                <span
                  v-if="imageUrl4"
                  class="el-upload-action"
                  @click.stop="handleRemove4()"
                >
                  <i class="el-icon-delete" />
                </span>
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="font-size: 12px"
                  >其他图片</i
                >
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="所属资质">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess5"
            :on-remove="handleRemove5"
            :before-upload="beforeAvatarUpload"
            accept=".jpg, .jpeg, .png"
          >
            <img v-if="imageUrl5" :src="imageUrl5" class="avatar" />
            <span
              v-if="imageUrl5"
              class="el-upload-action"
              @click.stop="handleRemove5()"
            >
              <i class="el-icon-delete" />
            </span>
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <div style="font-size: 13px; line-height: 20px; color: #2593fc">
            温馨提示：只能上传jpg/jpeg/png文件，且不超过2M
          </div>
        </el-form-item>
        <el-form-item label="备注说明" style="width: 500px">
          <el-input
            v-model="lastForm.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入备注说明"
          />
        </el-form-item>
        <el-form-item
          style="display: flex; flex-direction: column; text-align: center"
        >
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="onSubmit(true)">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { HOST } from "@/utils/host";
import { regionData, CodeToText } from "element-china-area-data";
import times from "./data.json";
let map = null; // 高德地图
export default {
  name: "Xiugaidianzhan",
  components: {},
  data() {
    var checkNumber = (rule, value, cb) => {
      if (value < 0) {
        cb(new Error("请输入非负数的费用金额"));
      } else {
        const reg =
          /^0$|^[1-9]\d{0,15}$|^[1-9]\d{0,15}\.{1}\d{1,4}$|^0\.{1}\d{1,4}$/g;
        if (reg.test(value)) {
          cb();
        } else {
          return cb(new Error("请输入正确数值"));
        }
      }
    };
    // 超时计费校验
    var validateOver = (rule, value, callback) => {
      const strP = /^[0-9]\d*$/;
      if (!value.money) {
        callback(new Error(`请输入超时收费`));
      } else if (!value.time) {
        callback(new Error(`请输入超时时长`));
      } else if (!strP.test(value.time)) {
        callback(new Error(`超时时长请输入正整数`));
      } else {
        callback();
      }
    };
    return {
      canAdd: false, // 是否可继续增加价格设置
      optionsThree: regionData, // 省市区数据
      shareArray: [],
      firstForm: {
        stationName: "",
        equipmentOwnerID: "",
        stationStatus: "",
        operatorStatus: "",
        areaCode: "",
        address: "",
        stationLocation: [],
        canAddCapacity: false,
        capacitanceSize: "",
        siteProperties: "独立场站",
        stationType: "",
        construction: "",
        stationLat: 0.0,
        stationLng: 0.0,
        appCanSee: false,
        officialRunTime: undefined,
        capacity: 0,
        electricityUserNo: "",
        powerSupplyType: 0,
        periodFee: 1,
        videoMonitor: 1,
      },
      restaurants: [{}],
      firstRules: {
        operatorStatus: [
          {
            required: true,
            message: "请选择运营状态",
            trigger: "change",
          },
        ],
        areaCode: [
          {
            required: true,
            message: "请选择电站地址",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
        stationLocation: [
          {
            required: true,
            message: "请选择电站位置",
            trigger: "blur",
          },
        ],
        // canAddCapacity: [
        //   { required: true, message: "请选择是否增容", trigger: "change" },
        // ],
        // capacitanceSize: [
        //   { required: true, message: "请输入可用电容", trigger: "blur" },
        // ],
        siteProperties: [
          {
            required: true,
            message: "请选择场地属性",
            trigger: "change",
          },
        ],
        stationType: [
          {
            required: true,
            message: "请选择电站类型",
            trigger: "change",
          },
        ],
        construction: [
          {
            required: true,
            message: "请选择建设场所",
            trigger: "change",
          },
        ],
        officialRunTime: [
          {
            required: true,
            message: "请选择开业时间",
            trigger: "change",
          },
        ],
        capacity: [
          {
            required: true,
            message: "请输入容量",
            trigger: "change",
          },
        ],
        periodFee: [
          {
            required: true,
            message: "请选择是否峰谷分时",
            trigger: "change",
          },
        ],
        videoMonitor: [
          {
            required: true,
            message: "请选择是否有监控",
            trigger: "change",
          },
        ],
        powerSupplyType: [
          {
            required: true,
            message: "请选择供电类型",
            trigger: "change",
          },
        ],
      },
      imageUrl: "",
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      imageUrl4: "",
      imageUrl5: "",
      isShowMap: false,
      newAddress: "",
      city: "", // 省市区三级联动
      editForm: {
        calculateMode: [],
        types: [
          {
            name: "",
            elecMoney: "",
            serviceMoney: "",
            priceType: 1,
          },
        ],
        ranges: [],
        end: 1,
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入价格类别名称",
            trigger: "blur",
          },
        ],
        calculateMode: [
          {
            required: true,
            message: "请选择支持计费模式",
            trigger: "change",
          },
        ],
        elecMoney: [
          {
            required: true,
            message: "请输入电费额度",
            trigger: "blur",
          },
          {
            validator: checkNumber,
            trigger: "blur",
          },
        ],
        serviceMoney: [
          {
            required: true,
            message: "请输入服务费额度",
            trigger: "blur",
          },
          {
            validator: checkNumber,
            trigger: "blur",
          },
        ],
        priceStartPeriod: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        priceEndPeriod: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "change",
          },
        ],
        priceType: [
          {
            required: true,
            message: "请选择价格类别",
            trigger: "change",
          },
        ],
      },
      profitForm: {
        mode: "PERCENT",
        shareBl: [
          {
            value: "",
            type: "operator",
          },
        ],
        shareJe: [
          {
            value: "",
            type: "",
          },
        ],
      },
      profitRules: {
        mode: [
          {
            required: true,
            message: "请选择分润模式",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择参与分润方",
            trigger: "change",
          },
        ],
        value: [
          {
            required: true,
            message: "请输入分润比例",
            trigger: "blur",
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
        value1: [
          {
            required: true,
            message: "请输入分润金额",
            trigger: "blur",
          },
          {
            pattern: /^\d*(?:\.\d{0,4})?$/,
            message: "请输入四位以内小数",
            trigger: "blur",
          },
        ],
      },
      occupyForm: {
        collect: false,
        buffDuration: "",
        overMoney: {
          money: "",
          time: "",
        },
      },
      occupyRules: {
        collect: [
          {
            required: true,
            message: "请选择是否收取占用费",
            trigger: "change",
          },
        ],
        buffDuration: [
          {
            required: true,
            message: "请输入预留给用户充完电拔枪离场时长",
            trigger: "blur",
          },
        ],
        overMoney: {
          validator: validateOver,
          trigger: "blur",
        },
      },
      lastForm: {
        brake: false,
        parkInstruction: "",
        stationRemark: "",
        busineHoursInstruction: "",
        mainEntrancePicture: "",
        markRoadPicture: "",
        stationViewPicture: "",
        pileFeaturePicture: "",
        otherPicture: "",
        qualificationPicture: "",
        remark: "",
        aroundService: [],
        siteService: [],
      },
      lastRules: {
        brake: [
          {
            required: true,
            message: "请选择否有道闸",
            trigger: "change",
          },
        ],
        parkInstruction: [
          {
            required: true,
            message: "请输入停车说明",
            trigger: "blur",
          },
        ],
        stationRemark: [
          {
            required: true,
            message: "请输入站点描述",
            trigger: "blur",
          },
        ],
      },
      priceTypeArray: [],
      id: "",
      recursion: {},
      isEnd: false,
      form: {},
      // plantList: [],
      startTimeList: [], // 开始时间集合
      endTimeList: [], // 结束时间集合
      token: window.localStorage.getItem("token"),
    };
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem("token"),
      };
    },
    action() {
      return HOST + "/oss";
    },
  },
  mounted() {
    this.startTimeList = this.timeInit(1);
    this.endTimeList = this.timeInit(0);
    this.getAlloperator();
    if (this.id) {
      const data = {
        id: this.id,
      };
      const that = this;
      this.$store.dispatch("form/handle", {
        url: "/station/getEditData",
        data: data,
        method: "get",
        callback: (resp) => {
          // console.log('resp', resp)
          this.firstForm.stationName = resp.stationName;
          this.firstForm.equipmentOwnerID = resp.operatorName;
          this.firstForm.operatorStatus = resp.operatorStatus;
          this.firstForm.stationStatus = resp.stationStatus;
          this.firstForm.address = resp.address;
          this.firstForm.stationLocation = resp.stationLocation.split(",");
          this.firstForm.canAddCapacity = resp.canAddCapacity;
          this.firstForm.capacitanceSize = resp.capacitanceSize;
          this.firstForm.siteProperties = resp.siteProperties;
          this.firstForm.stationType = resp.stationType;
          this.firstForm.construction = resp.construction;
          this.firstForm.stationLat = resp.stationLat;
          this.firstForm.stationLng = resp.stationLng;
          this.firstForm.appCanSee = resp.appCanSee;
          this.firstForm.officialRunTime = resp.officialRunTime;
          this.firstForm.capacity = resp.capacity;
          this.firstForm.electricityUserNo = resp.electricityUserNo;
          this.firstForm.powerSupplyType = resp.powerSupplyType;
          this.firstForm.periodFee = resp.periodFee;
          this.firstForm.videoMonitor = resp.videoMonitor;

          this.lastForm.brake = resp.brake;
          this.lastForm.parkInstruction = resp.parkInstruction;
          this.lastForm.busineHoursInstruction = resp.busineHoursInstruction;
          this.lastForm.mainEntrancePicture = resp.mainEntrancePicture;
          this.lastForm.markRoadPicture = resp.markRoadPicture;
          this.lastForm.stationViewPicture = resp.stationViewPicture;
          this.lastForm.pileFeaturePicture = resp.pileFeaturePicture;
          this.lastForm.otherPicture = resp.otherPicture;
          this.lastForm.qualificationPicture = resp.qualificationPicture;
          this.lastForm.remark = resp.remark;
          this.lastForm.stationRemark = resp.description;
          this.occupyForm.collect = resp.occupy;
          this.occupyForm.buffDuration = resp.bufferTime;
          this.occupyForm.overMoney.time = resp.overTime;
          this.occupyForm.overMoney.money = resp.overMoney;

          if (resp.siteService) {
            const site = resp.siteService.split(",");
            for (let i = 0; i < site.length; i++) {
              site[i] = Number(site[i]);
            }
            this.lastForm.siteService = site;
          }

          if (resp.aroundService) {
            const around = resp.aroundService.split(",");
            for (let i = 0; i < around.length; i++) {
              around[i] = Number(around[i]);
            }
            this.lastForm.aroundService = around;
          }
          if (resp.mainEntrancePicture) {
            this.imageUrl =
              HOST +
              "/oss?objectName=" +
              resp.mainEntrancePicture +
              "&token=" +
              this.token;
          }
          if (resp.markRoadPicture) {
            this.imageUrl1 =
              HOST +
              "/oss?objectName=" +
              resp.markRoadPicture +
              "&token=" +
              this.token;
          }
          if (resp.stationViewPicture) {
            this.imageUrl2 =
              HOST +
              "/oss?objectName=" +
              resp.stationViewPicture +
              "&token=" +
              this.token;
          }
          if (resp.pileFeaturePicture) {
            this.imageUrl3 =
              HOST +
              "/oss?objectName=" +
              resp.pileFeaturePicture +
              "&token=" +
              this.token;
          }
          if (resp.otherPicture) {
            this.imageUrl4 =
              HOST +
              "/oss?objectName=" +
              resp.otherPicture +
              "&token=" +
              this.token;
          }
          if (resp.qualificationPicture) {
            this.imageUrl5 =
              HOST +
              "/oss?objectName=" +
              resp.qualificationPicture +
              "&token=" +
              this.token;
          }
          this.firstForm.areaCode = resp.areaCode.split(",");
          if (
            resp.types === undefined ||
            resp.types == null ||
            resp.types.length === 0
          ) {
            this.editForm.types = [
              {
                name: "",
                elecMoney: 0,
                serviceMoney: 0,
                priceType: 0,
              },
            ];
          } else {
            this.editForm.types = resp.types;
            for (let i = 0; i < this.editForm.types.length; i++) {
              this.editForm.types[i].serviceMoney = this.getFloat(
                this.editForm.types[i].serviceMoney
              );
              this.editForm.types[i].elecMoney = this.getFloat(
                this.editForm.types[i].elecMoney
              );
              const type =
                this.editForm.types[i].name +
                "：" +
                "电费" +
                "【" +
                this.editForm.types[i].elecMoney +
                "元" +
                "】" +
                "服务费" +
                "【" +
                this.editForm.types[i].serviceMoney +
                "元" +
                "】";
              this.priceTypeArray.push({
                value: i + 1,
                label: type,
              });
            }
          }
          if (
            resp.ranges === undefined ||
            resp.ranges == null ||
            resp.ranges.length === 0
          ) {
            that.editForm.ranges = [];
          } else {
            that.editForm.ranges = [];
            resp.ranges.forEach(function (item, index) {
              // console.log(JSON.stringify(item))
              if (item.priceStartPeriod != "" && item.priceEndPeriod != "") {
                that.editForm.ranges.push({
                  cpoElecMoney: item.cpoElecMoney,
                  cpoServiceMoney: item.cpoServiceMoney,
                  priceStartPeriod: item.priceStartPeriod,
                  priceEndPeriod: item.priceEndPeriod,
                  priceType: item.priceType,
                  defaultRange: item.defaultRange,
                  startTimeList: [],
                  endTimeList: [],
                });
              } else {
                that.editForm.end = item.priceType;
                that.isEnd = true;
              }
            });
          }
          this.profitForm.mode = resp.profitMode;
          if (resp.profitConfigs && resp.profitConfigs.length > 0) {
            if (resp.profitMode === "PERCENT") {
              this.profitForm.shareBl = [
                {
                  value: "",
                  type: "operator",
                },
              ];
              resp.profitConfigs.forEach((item) => {
                this.profitForm.shareBl.push({
                  value: item.share,
                  type: item.targetId,
                });
              });
              this.$nextTick(() => {
                this.getOperator();
              });
            } else {
              this.profitForm.shareJe = [];
              resp.profitConfigs.forEach((item) => {
                this.profitForm.shareJe.push({
                  value: item.share,
                  type: item.targetId,
                });
              });
            }
          }
        },
      });
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data;
    // this.selectPlant()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    handlePriceChange(val, index) {
      // console.log('111',val, index, this.editForm.ranges);
    },
    getAlloperator() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
      };
      this.$store.dispatch("form/handle", {
        url: "/user/page",
        data: data,
        method: "get",
        callback: (resp) => {
          if (resp.list && resp.list.length > 0) {
            this.shareArray = resp.list;
          }
        },
      });
    },
    // 计算运营商分润比例
    getOperator() {
      if (this.profitForm.shareBl.length > 1) {
        let num = 100;
        this.profitForm.shareBl.forEach((item, i) => {
          if (i > 0) {
            num = num - Number(item.value);
          }
        });
        const reg = /^\d+(?=\.{0,1}\d+$|$)/;
        if (reg.test(num)) {
          this.profitForm.shareBl[0].value = num;
        } else {
          this.$notify.error({
            title: "错误",
            message: "所有分润方比例相加超出100%",
          });
        }
      }
    },
    // 增加分润方和比例
    addshareBl() {
      const data = {
        type: "",
        value: "",
      };
      this.profitForm.shareBl.push(data);
    },
    // 增加分润方和金额
    addshareJe() {
      const data = {
        type: "",
        value: "",
      };
      this.profitForm.shareJe.push(data);
    },
    // 删除分润方和比例
    delshareBl(index) {
      this.profitForm.shareBl.splice(index, 1);
    },
    // 删除分润方和金额
    delshareJe(index) {
      this.profitForm.shareJe.splice(index, 1);
    },
    checkCap(_value) {
      _value = _value.replace(/^(0+)|[^\d]+/g, "");
      this.firstForm.capacitanceSize = _value;
    },
    async onSubmit(flag) {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.firstForm.validate(),
          this.$refs.editForm.validate(),
          this.$refs.profitForm.validate(),
          // this.$refs.occupyForm.validate(),
          this.$refs.lastForm.validate(),
        ]);
      } catch (error) {
        return;
      }

      if (!flag) {
        this.$router.go(-1);
        return;
      }

      const newRanges = [];
      for (let i = 0; i < this.editForm.ranges.length; i++) {
        for (let j = 0; j < this.editForm.types.length; j++) {
          if (
            this.editForm.ranges[i].priceType ===
            this.editForm.types[j].priceType
          ) {
            newRanges.push({
              priceStartPeriod: this.editForm.ranges[i].priceStartPeriod,
              priceEndPeriod: this.editForm.ranges[i].priceEndPeriod,
              priceType: this.editForm.ranges[i].priceType,
              defaultRange: this.editForm.ranges[i].defaultRange,
              cpoElecMoney:
                this.editForm.types[this.editForm.ranges[i].priceType - 1]
                  .elecMoney,
              cpoServiceMoney:
                this.editForm.types[this.editForm.ranges[i].priceType - 1]
                  .serviceMoney,
            });
          }
        }
      }

      if (newRanges.length < 48) {
        newRanges.push({
          priceStartPeriod: 0,
          priceEndPeriod: 0,
          priceType: this.editForm.end,
          defaultRange: true,
          cpoElecMoney: this.editForm.types[this.editForm.end - 1].elecMoney,
          cpoServiceMoney:
            this.editForm.types[this.editForm.end - 1].serviceMoney,
        });
      }

      let itemId = "";
      if (this.id) {
        itemId = this.id;
      }

      let site = "";
      let around = "";
      if (
        this.lastForm.siteService !== [] &&
        typeof this.lastForm.siteService !== "string"
      ) {
        site = this.lastForm.siteService.join(",");
      } else {
        site = "";
      }

      if (
        this.lastForm.aroundService !== [] &&
        typeof this.lastForm.siteService !== "string"
      ) {
        around = this.lastForm.aroundService.join(",");
      } else {
        around = "";
      }

      let area = "";
      if (Array.isArray(this.firstForm.areaCode)) {
        area = this.firstForm.areaCode.join(",");
      } else {
        area = this.firstForm.areaCode;
      }
      // 接口数据
      this.form = {
        // stationName: this.firstForm.stationName,
        // equipmentOwnerID: this.firstForm.equipmentOwnerID,
        operatorStatus: this.firstForm.operatorStatus,
        stationStatus: this.firstForm.stationStatus,
        areaCode: area,
        address: this.firstForm.address,
        stationLocation: this.firstForm.stationLocation.join(","),
        canAddCapacity: this.firstForm.canAddCapacity,
        capacitanceSize: this.firstForm.capacitanceSize,
        id: itemId,
        stationLat: this.firstForm.stationLat,
        stationLng: this.firstForm.stationLng,
        siteProperties: this.firstForm.siteProperties,
        stationType: this.firstForm.stationType,
        construction: this.firstForm.construction,
        appCanSee: this.firstForm.appCanSee,
        brake: this.lastForm.brake,
        parkInstruction: this.lastForm.parkInstruction,
        busineHoursInstruction: this.lastForm.busineHoursInstruction,
        mainEntrancePicture: this.lastForm.mainEntrancePicture,
        markRoadPicture: this.lastForm.markRoadPicture,
        stationViewPicture: this.lastForm.stationViewPicture,
        pileFeaturePicture: this.lastForm.pileFeaturePicture,
        otherPicture: this.lastForm.otherPicture,
        qualificationPicture: this.lastForm.qualificationPicture,
        remark: this.lastForm.remark,
        siteService: site,
        aroundService: around,
        occupy: this.occupyForm.collect,
        bufferTime: this.occupyForm.buffDuration,
        overTime: this.occupyForm.overMoney.time,
        overMoney: this.occupyForm.overMoney.money,
        description: this.lastForm.stationRemark,
        officialRunTime: this.firstForm.officialRunTime,
        capacity: this.firstForm.capacity,
        electricityUserNo: this.firstForm.electricityUserNo,
        powerSupplyType: this.firstForm.powerSupplyType,
        periodFee: this.firstForm.periodFee,
        videoMonitor: this.firstForm.videoMonitor,
      };

      // console.log(this.form);
      const data = this.form;
      data.types = this.editForm.types;
      data.ranges = newRanges;
      data.profitMode = this.profitForm.mode;
      data.profitConfigs = [];
      if (
        this.profitForm.mode === "PERCENT" &&
        this.profitForm.shareBl.length > 0
      ) {
        this.profitForm.shareBl.forEach((item) => {
          if (item.type !== "operator") {
            data.profitConfigs.push({
              share: item.value,
              targetId: item.type,
            });
          }
        });
      } else if (this.profitForm.shareJe.length > 0) {
        this.profitForm.shareJe.forEach((item) => {
          data.profitConfigs.push({
            share: item.value,
            targetId: item.type,
          });
        });
      }
      // console.log('查看参数data：', data);
      this.$store.dispatch("form/handle", {
        url: "/station",
        data: data,
        method: "post",
        callback: (resp) => {
          if (resp) {
            this.$confirm(
              "当前电站存在单独定价桩，此次修改会同步更新桩的价格，请按需前往重新设置桩的价格！",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                // type: 'warning',
                callback: (action) => {
                  this.$router.go(-1);
                },
              }
            );
          } else {
            this.$router.go(-1);
          }
        },
      });
    },

    cancel() {
      this.$router.go(-1);
    },

    handleChange() {
      this.city = this.$refs.three.getCheckedNodes()[0].pathLabels.join(",");
      this.firstForm.areaCode = this.firstForm.areaCode.join(",");
      console.log(this.firstForm.areaCode);
    },

    // 主入口图
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.lastForm.mainEntrancePicture = res.data.fileName;
    },
    handleRemove() {
      this.imageUrl = "";
      this.lastForm.mainEntrancePicture = "";
    },
    // 标志路径
    handleAvatarSuccess1(res, file) {
      this.imageUrl1 = URL.createObjectURL(file.raw);
      this.lastForm.markRoadPicture = res.data.fileName;
    },
    handleRemove1() {
      this.imageUrl1 = "";
      this.lastForm.markRoadPicture = "";
    },
    // 电站全景
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw);
      this.lastForm.stationViewPicture = res.data.fileName;
    },
    handleRemove2() {
      this.imageUrl2 = "";
      this.lastForm.stationViewPicture = "";
    },
    // 电桩特写
    handleAvatarSuccess3(res, file) {
      this.imageUrl3 = URL.createObjectURL(file.raw);
      this.lastForm.pileFeaturePicture = res.data.fileName;
    },
    handleRemove3() {
      this.imageUrl3 = "";
      this.lastForm.pileFeaturePicture = "";
    },
    // 其他图片
    handleAvatarSuccess4(res, file) {
      this.imageUrl4 = URL.createObjectURL(file.raw);
      this.lastForm.otherPicture = res.data.fileName;
    },
    handleRemove4() {
      this.imageUrl4 = "";
      this.lastForm.otherPicture = "";
    },
    // 所属资质
    handleAvatarSuccess5(res, file) {
      this.imageUrl5 = URL.createObjectURL(file.raw);
      this.lastForm.qualificationPicture = res.data.fileName;
    },
    handleRemove5() {
      this.imageUrl5 = "";
      this.lastForm.qualificationPicture = "";
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg";
      const isLt2M = file.size <= 2097152;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/JEPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    selectFocusTime(type, index, item) {
      if (type === 1) {
        // 选择开始时间
        for (let i = 0; i < 48; i++) {
          this.startTimeList[i].disabled = false;
        }
        if (item.priceEndPeriod) {
          // 当前区间有结束时间时，结束时间之后的开始时间选项置灰
          for (let i = item.priceEndPeriod - 1; i < 48; i++) {
            this.startTimeList[i].disabled = true;
          }
        }
        for (let i = 0; i < this.editForm.ranges.length; i++) {
          const tmp = this.editForm.ranges[i];
          if (i !== index) {
            // 非当前时间区间
            if (
              item.priceEndPeriod &&
              item.priceEndPeriod > tmp.priceEndPeriod
            ) {
              // 如有当前结束时间且当前结束时间>已选结束时间，已选结束时间之前置灰
              for (let j = 0; j < tmp.priceEndPeriod - 1; j++) {
                this.startTimeList[j].disabled = true;
              }
            } else {
              // 将已选时间区间的时间选项置灰
              for (
                let j = tmp.priceStartPeriod - 1;
                j < tmp.priceEndPeriod - 1;
                j++
              ) {
                this.startTimeList[j].disabled = true;
              }
            }
          }
        }
      } else {
        // 选择结束时间
        for (let i = 1; i < 49; i++) {
          this.endTimeList[i].disabled = false;
        }
        if (item.priceStartPeriod) {
          // 当前区间有开始时间时，开始时间之前的开始时间选项置灰
          for (let i = 1; i < item.priceStartPeriod; i++) {
            this.endTimeList[i].disabled = true;
          }
        }
        for (let i = 0; i < this.editForm.ranges.length; i++) {
          const tmp = this.editForm.ranges[i];
          if (i !== index) {
            // 非当前时间区间
            if (
              item.priceStartPeriod &&
              item.priceStartPeriod < tmp.priceStartPeriod
            ) {
              // 如果当前开始时间且当前开始时间<已选当前时间，已选当前时间之后的选项置灰
              for (let j = tmp.priceStartPeriod; j < 49; j++) {
                this.endTimeList[j].disabled = true;
              }
            } else {
              // 将已选时间区间的时间选项置灰
              for (let j = tmp.priceStartPeriod; j < tmp.priceEndPeriod; j++) {
                this.endTimeList[j].disabled = true;
              }
            }
          }
        }
      }
    },
    isShowMapClick() {
      this.isShowMap = true;
      if (!this.city) {
        for (var i = 0; i < this.firstForm.areaCode.length; i++) {
          this.city += CodeToText[this.firstForm.areaCode[i]];
        }
      }
      const address = this.city + this.firstForm.address;
      this.markLocation("container", address);
    },

    markLocation(mapId, address) {
      AMap.plugin("AMap.Geocoder", () => {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
        // 创建地图
        map = new AMap.Map(mapId, {
          // mapStyle: 'amap://styles/grey',
          zoom: 13,
          center: [120.220876, 33.423722],
        });
        geocoder.getLocation(address, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            // 经纬度
            var lng = result.geocodes[0].location.lng;
            var lat = result.geocodes[0].location.lat;
            // 添加标记
            const marker = new AMap.Marker({
              position: new AMap.LngLat(lng, lat), // 经纬度
            });
            map.add(marker); // 加载点
            map.setFitView(); // 缩放至地图

            geocoder.getAddress([lng, lat], (status, result) => {
              if (status === "complete" && result.info === "OK") {
                // result为对应的地理位置详细信息
                console.log(result.regeocode.formattedAddress);
                this.newAddress =
                  result.regeocode.formattedAddress +
                  "(" +
                  lng +
                  "," +
                  lat +
                  ")";
                this.firstForm.stationLat = lat;
                this.firstForm.stationLng = lng;
              }
            });
          } else {
            console.log("定位失败", status);
          }
        });

        // 地图点击事件
        map.on("click", (e) => {
          map.clearMap(); // 清理地图
          const lng = e.lnglat.getLng(); // 获取经度
          const lat = e.lnglat.getLat(); // 获取纬度
          var lnglat = [lng, lat];
          // marker点
          const marker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-13, -30),
          });
          map.add(marker); // 加载点
          map.setFitView(); // 缩放至地图
          geocoder.getAddress(lnglat, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              // result为对应的地理位置详细信息
              console.log(result.regeocode.formattedAddress);
              this.newAddress =
                result.regeocode.formattedAddress +
                "(" +
                lnglat[0] +
                "," +
                lnglat[1] +
                ")";
              this.firstForm.stationLat = lnglat[1];
              this.firstForm.stationLng = lnglat[0];
            }
          });
        });
      });
    },

    // 添加价格区间列
    addRow() {
      // this.editForm.ranges = [];

      // 深拷贝对象
      const newStart = JSON.parse(JSON.stringify(times.timeList));
      const newEnd = JSON.parse(JSON.stringify(times.timeList));

      for (let i = 0; i < newStart.length; i++) {
        if (newStart[i].value === 49) {
          newStart[i].disabled = true;
        }
      }

      for (let i = 0; i < newEnd.length; i++) {
        if (newEnd[i].value === 1) {
          newEnd[i].disabled = true;
        }
      }

      if (this.editForm.ranges.length < 1) {
        this.editForm.ranges.push({
          cpoElecMoney: 0,
          cpoServiceMoney: 0,
          priceStartPeriod: "",
          priceEndPeriod: "",
          priceType: 1,
          defaultRange: false,
          startTimeList: [],
          endTimeList: [],
        });

        this.isEnd = true;
      }
      if (this.editForm.types.length > 9) {
        return;
      } else if (
        this.editForm.types[this.editForm.types.length - 1].name === "" ||
        this.editForm.types[this.editForm.types.length - 1].elecMoney === 0 ||
        this.editForm.types[this.editForm.types.length - 1].serviceMoney === 0
      ) {
        this.$refs.editForm.validate();
        return;
      } else {
        this.editForm.types.push({
          name: "",
          elecMoney: "",
          serviceMoney: "",
          priceType: this.editForm.types.length + 1,
        });
      }
    },

    // 删除价格区间列
    removeRow(index) {
      let newval = "";
      if (this.priceTypeArray[index]) {
        newval = this.priceTypeArray[index].value;
        this.priceTypeArray.splice(index, 1);
      }
      this.editForm.types.splice(index, 1);
      if (this.editForm.types.length < 2) {
        this.editForm.ranges = [];
      } else {
        const haveType = [];
        for (let j = 0; j < this.priceTypeArray.length; j++) {
          haveType.push(this.priceTypeArray[j].value);
        }
        for (let i = 0; i < this.editForm.ranges.length; i++) {
          if (!haveType.includes(this.editForm.ranges[i].priceType)) {
            this.editForm.ranges[i].priceType = "";
          }
        }
      }
      if (newval && this.editForm.end == newval) {
        this.editForm.end = this.priceTypeArray[0].value;
      }
      // console.log('价格类别删除', this.priceTypeArray, this.editForm.types, this.editForm.ranges);
      // 重排价格类别顺序
      this.editForm.ranges.forEach((item, i) => {
        this.priceTypeArray.forEach((item2, index2) => {
          if (item.priceType === item2.value) {
            item.label = item2.label;
          }
        });
      });
      this.priceTypeArray = [];
      this.editForm.types.forEach((item, index) => {
        item.priceType = index + 1;
        const type =
          item.name +
          "：" +
          "电费" +
          "【" +
          this.getFloat(item.elecMoney) +
          "元" +
          "】" +
          "服务费" +
          "【" +
          this.getFloat(item.serviceMoney) +
          "元" +
          "】";
        this.priceTypeArray.push({ label: type, value: item.priceType });
        this.editForm.ranges.forEach((item2) => {
          if (item2.label === type) {
            item2.priceType = item.priceType;
          }
        });

        // this.priceTypeArray[index].label=type
        // this.priceTypeArray[index].value=index+1
      });
    },

    // 添加时间区间列
    addPriceTypeRow() {
      if (this.editForm.ranges.length >= 1) {
        if (
          this.editForm.ranges[this.editForm.ranges.length - 1]
            .priceStartPeriod === "" ||
          this.editForm.ranges[this.editForm.ranges.length - 1]
            .priceEndPeriod === ""
        ) {
          this.$refs.editForm.validate();
        } else {
          this.editForm.ranges.push({
            cpoElecMoney: 0,
            cpoServiceMoney: 0,
            priceStartPeriod: "",
            priceEndPeriod: "",
            priceType: 1,
            defaultRange: false,
            startTimeList: [],
            endTimeList: [],
          });
          if (this.editForm.ranges.length === 48) {
            this.isEnd = false;
          }

          this.editForm.ranges[
            this.editForm.ranges.length - 1
          ].startTimeList.map((ele) => {
            if (ele) {
              this.editForm.ranges.map((val) => {
                if (
                  Number(ele.value) >= Number(val.priceStartPeriod) &&
                  Number(ele.value) < Number(val.priceEndPeriod)
                ) {
                  ele.disabled = true;
                }
              });
            }
          });
          const bbb =
            this.editForm.ranges[this.editForm.ranges.length - 1].startTimeList;

          if (bbb.length > 0) {
            this.editForm.ranges.map((ele) => {
              for (let i = 0; i < bbb.length; i++) {
                if (ele.priceStartPeriod === 0 && bbb[i].value === 0) {
                  bbb[i].disabled = true;
                }
                if (i !== 0) {
                  if (
                    bbb[i].disabled === false &&
                    bbb[i - 1].disabled === true &&
                    bbb[i + 1].disabled === true
                  ) {
                    bbb[i].disabled = true;
                  }
                }
              }
            });
          }
          this.editForm.ranges[this.editForm.ranges.length - 1].endTimeList =
            JSON.parse(
              JSON.stringify(
                this.editForm.ranges[this.editForm.ranges.length - 1]
                  .startTimeList
              )
            );
          if (
            this.editForm.ranges[this.editForm.ranges.length - 1].endTimeList
              .length > 0
          ) {
            this.editForm.ranges[
              this.editForm.ranges.length - 1
            ].endTimeList[0].disabled = true;
          }
          if (
            this.editForm.ranges[this.editForm.ranges.length - 1].startTimeList
              .length > 0
          ) {
            this.editForm.ranges[
              this.editForm.ranges.length - 1
            ].startTimeList[48].disabled = true;
          }
        }
      }
    },

    // 删除时间区间列
    removePriceTypeRow(index) {
      this.editForm.ranges.splice(index, 1);
      this.canAdd = false;
      this.isEnd = true;
    },
    startTime() {},
    endTime() {
      console.log(this.timeList, this.startTimeList, this.endTimeList);
    },

    changeElecMoney(val) {
      console.log("lecMoney", val);
      this.editForm.types.map((res) => {
        if (res.elecMoney === val) {
          res.elecMoney = this.getFloat(res.elecMoney);
        }
      });
    },

    changeServiceMoney(val) {
      console.log("ServiceMoney", val);
      this.editForm.types.map((res) => {
        if (res.serviceMoney === val) {
          res.serviceMoney = this.getFloat(res.serviceMoney);
        }
      });
    },

    // 添加价格类别
    addPriceTypeClick() {
      // console.log('000', this.editForm.types);
      this.priceTypeArray = [];
      for (let i = 0; i < this.editForm.types.length; i++) {
        const type =
          this.editForm.types[i].name +
          "：" +
          "电费" +
          "【" +
          this.getFloat(this.editForm.types[i].elecMoney) +
          "元" +
          "】" +
          "服务费" +
          "【" +
          this.getFloat(this.editForm.types[i].serviceMoney) +
          "元" +
          "】";

        this.priceTypeArray.push({
          value: i + 1,
          label: type,
        });
      }
    },

    // 选择开始时间
    selectedStartTime(item, index) {
      if (item.priceStartPeriod === 0) {
        this.editForm.ranges.map((ele) => {
          ele.startTimeList[0].disabled = true;
        });
      }
      if (this.editForm.ranges.length > 1) {
        item.endTimeList.map((ele) => {
          if (Number(ele.value) <= Number(item.priceStartPeriod)) {
            ele.disabled = true;
          }
          const aa = this.editForm.ranges.map((val) => {
            if (Number(val.priceStartPeriod) > Number(item.priceStartPeriod)) {
              return val.priceStartPeriod;
            }
          });
          if (Number(ele.value) > Number(aa[0])) {
            ele.disabled = true;
          }
          if (Number(ele.value) === Number(aa[0])) {
            ele.disabled = false;
          }
        });
      } else {
        item.endTimeList.map((ele) => {
          if (Number(ele.value) <= Number(item.priceStartPeriod)) {
            ele.disabled = true;
          }
        });
      }
    },

    // 选择结束时间
    selectedEndTime(item, index) {
      item.startTimeList.map((ele) => {
        if (Number(ele.value) >= Number(item.priceEndPeriod)) {
          ele.disabled = true;
        }
      });
      const that = this;
      if (this.editForm.ranges.length > 0) {
        this.editForm.ranges.forEach((el, em) => {
          if (
            el.priceStartPeriod === item.priceStartPeriod &&
            el.priceEndPeriod === item.priceEndPeriod &&
            em === that.editForm.ranges.length - 1
          ) {
            this.editForm.ranges.map((el) => {
              if (
                el.priceStartPeriod !== item.priceStartPeriod &&
                el.priceEndPeriod !== item.priceEndPeriod
              ) {
                el.endTimeList.map((em) => {
                  if (Number(em.value) > Number(item.priceStartPeriod)) {
                    em.disabled = true;
                  }
                });
              }
            });
          }
        });
      }
    },

    startShowClick(e, item, index) {},

    endShowClick(e, item, index) {},
    canAddBtn(val) {
      console.log(val, "val");
      if (val === 49) {
        this.canAdd = true;
      } else {
        this.canAdd = false;
      }
    },
    timeInit(type) {
      const timeBlock = [];
      for (let i = 0; i < 49; i++) {
        let a = 1;
        let b = 0;
        let label = "";
        let value = 0;
        let temp = {};
        a = Math.floor(i / 2);
        a = a > 9 ? a.toString() : `0${a}`;
        b = (i % 2) * 30;
        b = b === 30 ? b.toString() : `${b}0`;

        label = `${a}:${b}`;
        value = i;

        if (type === 0) {
          temp = {
            label,
            value: value + 1,
            disabled: i === 0,
          };
        } else {
          temp = {
            label,
            value: value + 1,
            disabled: i === 48,
          };
        }
        timeBlock[i.toString()] = temp;
      }
      return timeBlock;
    },
    // selectPlant(val) {
    //   const data = {
    //     text: val
    //   }
    //   this.$store.dispatch('form/handle', {
    //     url: '/station/getOperatorByText',
    //     data: data,
    //     method: 'get',
    //     callback: (resp) => {
    //       this.plantList = resp
    //     }
    //   })
    // }
  }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

#container {
  width: 500px;
  height: 400px;
}

.el-upload-action {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0;
  color: #fff;
  text-align: center;
  line-height: 120px;
}

.el-upload-action:hover {
  font-size: 20px;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.3);
}
.form-card {
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  margin-top: 20px;
  .el-icon-remove {
    color: #f78989;
    font-size: 24px;
    height: 40px;
    line-height: 40px;
  }
  .el-icon-circle-plus {
    color: #409eff;
    font-size: 24px;
    height: 40px;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/revisePlant.vue